import React, { useState } from 'react';
import { ErrorMessage, Field } from 'formik';
import Proptypes from 'prop-types';
import StyledInput from '../styledComponents/StyledInput';
import { formErrorMessage } from './FormErrorMessage';
import EyeIcon from '../svgIcons/EyeIcon';
import EyeHideIcon from '../svgIcons/EyeHideIcon';
import styled from 'styled-components';

const FormikInputField = ({
  name,
  type = 'text',
  isHideError,
  $phColor = '',
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => setShowPassword(!showPassword);

  return (
    <Field name={name}>
      {({ field, form: { touched, errors, submitCount } }) => (
        <>
          <StyledInput
            {...field}
            type={
              type === 'password' ? (showPassword ? 'text' : 'password') : type
            }
            isinvalid={submitCount && touched[field.name] && errors[field.name]}
            id={props.id}
            newinput={props?.newInput?.toString()}
            $phcolor={$phColor}
            {...props}
          />
          {type === 'password' && (
            <div className="position-relative">
              <StyledIcon
                className={`position-absolute cursor-pointer  ${
                  name ? name : ''
                }`}
                style={{
                  top: '-22px',
                  right: '10px',
                  transform: 'translateY(-50%)',
                }}
                onClick={toggleShowPassword}
              >
                {showPassword ? <EyeHideIcon /> : <EyeIcon />}
              </StyledIcon>
            </div>
          )}
          {submitCount > 0 && !isHideError && (
            <ErrorMessage name={field.name} render={formErrorMessage} />
          )}
        </>
      )}
    </Field>
  );
};

const StyledIcon = styled.div`
  color: ${({ theme }) => theme.primaryDark};
`;
FormikInputField.propTypes = {
  name: Proptypes.string.isRequired,
  placeholder: Proptypes.string,
  type: Proptypes.string,
  as: Proptypes.string,
  rows: Proptypes.string,
};
export default React.memo(FormikInputField);
